import { createContext, useEffect, useState } from "react";
import axios from "axios";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
	const [auth, setAuth] = useState(() => {
		try {
			const stored = localStorage.getItem("auth");
			return stored ? JSON.parse(stored) : {};
		} catch {
			return {};
		}
	});
	const [authLoading, setAuthLoading] = useState(true);

	useEffect(() => {
		try {
			localStorage.setItem("auth", JSON.stringify(auth || {}));
		} catch {
			// ignore storage errors
		}
	}, [auth]);

	useEffect(() => {
		let mounted = true;
		const handleSessionExpired = () => {
			if (mounted) setAuth({});
		};
		window.addEventListener("auth:session-expired", handleSessionExpired);
		const restoreSession = async () => {
			try {
				const { data } = await axios.get(`${process.env.REACT_APP_API_URL}refresh`, {
					withCredentials: true,
				});
				if (mounted && data?.accessToken) {
					setAuth(data);
				}
			} catch {
				// no active session cookie
			} finally {
				if (mounted) setAuthLoading(false);
			}
		};
		restoreSession();
		return () => {
			mounted = false;
			window.removeEventListener("auth:session-expired", handleSessionExpired);
		};
	}, []);

	return (
		<AuthContext.Provider value={{ auth, setAuth, authLoading }}>
			{children}
		</AuthContext.Provider>
	);
};

export default AuthContext;
